import { memoize } from './utils/js_utils';
export var isFirefox = memoize(function () {
  return /firefox/i.test(navigator.userAgent);
});
export var isSafari = memoize(function () {
  return Boolean(window.safari);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-dnd-html5-backend/dist/esm/BrowserDetector.js
// module id = 1890
// module chunks = 0